import cnaesMetadata from './data/metadata.json';
import type { CnaesDataVersion } from './types.js';

export const CNAES_DATA_VERSION: CnaesDataVersion = cnaesMetadata as CnaesDataVersion;
